import { NgOptimizedImage } from "@angular/common";
import { Component, inject, output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../services/user.service";

@Component({
    selector: "app-navbar",
    imports: [MatIconModule, MatButtonModule, NgOptimizedImage, MatMenuModule],
    templateUrl: "./navbar.html",
    styleUrl: "./navbar.scss",
})
export class Navbar {
    toggleDrawer = output();

    protected userService = inject(UserService);
    private router = inject(Router);

    routeToHome(): void {
        if (!this.userService.currentUser()) {
            void this.router.navigateByUrl('login');
            return;
        }
        void this.router.navigateByUrl("/");
    }

    protected logout(): void {
        this.userService.logout();
        void this.router.navigateByUrl('login');
    }
}
